/* eslint-disable jsx-a11y/anchor-is-valid */
import React,{useEffect} from "react";

import HeaderTitle from "../../components/includes/HeaderTitle";
import VariablesPage from "../../components/environments/VariablesPage";
import {LoginAfterCheckLogin} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin.css";
import "../../../css/admin_board.css";
import "../../../css/variables.css";

const Variables = ({setMenuType,setMenuItem}) => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검
  useEffect(() => {
    setMenuType('ENVIRONMENT');
    setMenuItem('Variables');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div id="admin_contents">
      <HeaderTitle varMenuTitle="설정관리" varPageTitle="카테고리 관리" />
      <div className="admin-content">
        <div className="main-box">
          <table className="select-list2" style={{borderCollapse:"collapse"}}>
            <thead></thead>
            <tbody>
              {/* 소속 */}
              <VariablesPage varMode={1}/>
              {/* 직위 */}
              <VariablesPage varMode={2}/>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
export default Variables;